import HomePage from './views/homePage';
import CalendarPage from './views/calendarPage';
import ContactPage from './views/contactPage';
import DocumentPage from './views/documentPage';
import BlogPage from './views/blogPage';
import BlogDetailPage from './views/blogDetailPage';
import FolderBlogPage from './views/folderBlogPage';
import FolderBlogDetailPage from './views/folderBlogDetailPage';
import Service1Page from './views/service1Page';
import LoginPage from './views/loginPage';
import PrecautionsPage from './views/precautionsPage';
import Employees from './views/employees';
import Library from './views/libraryPage';
import LiderboardPage from './views/liderboardPage'

import ForgetPassword from './views/forgetPassword';
import PoolPage from './views/poolPage';
import PoolImagePage from './views/poolImagePage';


import NewMemberPreview from './views/newMemberPreview';

import ShopPage from './views/shopPage';
import ShopDetailPage from './views/shopDetailPage';

import { API_ENDPOINT } from './constants';
import ChangePassword from './views/changePassword';
import InterniShop from './views/interniShop';
import PoolVideoPage from './views/poolVideoPage';

const linkTranslates = {

    'en': {
        '/': '/en',
        '/dostavne-linije': '/en/delivery-lines',
        '/dokumenti': '/en/documents',
        '/kalendar': '/en/calendar',
        '/:category/novosti/:submenu': '/en/:category/blog/:submenu',
        '/:category/novosti/:submenu/:alias': '/en/:category/blog/:submenu/:alias',
        '/:category/novosti/:submenu/folder/:folder': '/en/:category/novosti/:submenu/folder/:folder',
        '/:category/novosti/:submenu/folder/:folder/:alias': '/en/:category/novosti/:submenu/folder/:folder/:alias',
        '/kontakt': '/en/contact',
        '/prijava': '/en/login',
        '/zaboravljena-lozinka': '/en/zaboravljena-lozinka',
        '/mjere-predostroznosti': '/en/precautions',
        '/arhiva-novosti': '/en/all-blogs',
        '/predstavljanje-novozaposlenih': '/en/ddd',
        '/podesavanja': '/en/settings',
        '/interni-shop': '/en/interni/shop',
        '/interni-shop/:category/:id': '/en/interni-shop/:category/:id',
        '/interne-novosti/interna-biblioteka': '/interne-novosti/interna-biblioteka',
        '/anketa': '/en/anketa',
        '/novi-clan': '/en/novi-clan',
        '/anketa-video': '/en/anketa-video',
        '/anketa-slike': '/en/anketa-slike',
        '/:category/dokumenti': '/en/:category/dokumenti',
        '/projects': '/en/projects'
    },
}

export const routes = [
    {
        path: "/",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Početna'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: HomePage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/pools/all`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        pool: data,
                        answers: data.answers,
                        comments: data.comments
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/data/dynamic-tables/project/projectNameData/couriers?entries=3`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
                    }
                })
                    .then(res => {
                        if (!res.ok) {
                            throw new Error(`HTTP error! status: ${res.status}`);
                        }
                        return res.text(); // Prvo uzmi text
                    })
                    .then(text => {
                        try {
                            const data = JSON.parse(text); // Onda parsiraj
                            return {
                                items: data.data || [],
                                show: data.show || {}
                            }
                        } catch (e) {
                            console.error('Failed to parse JSON for couriers:', text);
                            return {
                                items: [],
                                show: {}
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching couriers:', error);
                        return {
                            items: [],
                            show: {}
                        }
                    })
            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/data/dynamic-tables/project/projectNameData/karticnaplacanja?entries=3`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
                    }
                })
                    .then(res => {
                        if (!res.ok) {
                            throw new Error(`HTTP error! status: ${res.status}`);
                        }
                        return res.text(); // Prvo uzmi text
                    })
                    .then(text => {
                        try {
                            const data = JSON.parse(text); // Onda parsiraj
                            return {
                                leaderboards: data.data || [],
                                showLeaderboards: data.show || {}
                            }
                        } catch (e) {
                            console.error('Failed to parse JSON for karticnaplacanja:', text);
                            return {
                                leaderboards: [],
                                showLeaderboards: {}
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching karticnaplacanja:', error);
                        return {
                            leaderboards: [],
                            showLeaderboards: {}
                        }
                    })
            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home/latest/articles`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].dateTS = new Date(data[i].date + " " + data[i].time).getTime() / 1000;
                    }
                    return {
                        homeLatestArticles: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/employee`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((result) => {

                    return {
                        newMember: result.items
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/library`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((result) => {

                    return {
                        library: result.items
                    }
                })

            }





        ]

    },
    {
        path: "/prijava",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Login'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: LoginPage,
        loadData: []
    },
    {
        path: "/zaboravljena-lozinka",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Zaboravljena lozinka'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: ForgetPassword,
        loadData: []
    },

    {
        path: "/kalendar",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Kalendar odsutnih'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: CalendarPage,
        loadData: [
            // (fetchFunction, lang, match) => {
            //     // console.log(this.props.user)
            //     return fetchFunction(`${API_ENDPOINT}/absence`, {
            //         method: 'GET',
            //         headers: {
            //             'content-type': 'application/json'
            //         }
            //     }).then(res => res.json()).then((data) => {
            //         return {
            //             data
            //         }
            //     })

            // },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }
            // (fetchFunction, lang, match) => {
            //     return fetchFunction(`${API_ENDPOINT}/blog/latest`, {
            //         method: 'GET',
            //         headers: {
            //             'content-type': 'application/json'
            //         },

            //     }).then(res => res.json()).then((result) => {

            //         return {
            //             latestBlog: result,
            //         }
            //     })

            // }



        ]

    },

    {
        path: "/interni-shop",

        generateSeoTags: (data, lang) => {
            return {
                title: 'Interni shop'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: ShopPage,
        loadData: [

            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }

        ],
        loadDataWithQuery: [
            // (fetchFunction, lang, match, query) => {
            //     return fetchFunction(`${API_ENDPOINT}/shop/articles/all`, {
            //         method: 'POST',
            //         headers: {
            //             'content-type': 'application/json',
            //             'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
            //         },
            //         body: JSON.stringify({
            //             page: query.page,
            //             lang: lang,
            //             limit: 9
            //         })
            //     }).then(res => res.json()).then((result) => {
            //         // for (let i = 0; i < result.items.length; i++) {
            //         //     result.items[i].dateTS = new Date(result.items[i].date + " " + result.items[i].time).getTime() / 1000;
            //         // }
            //         return {
            //             page: query.page ? query.page : 0,
            //             items: result.items,
            //             total: result.total,

            //         }
            //     })

            // },
            // (fetchFunction, lang, match, query) => {
            //     return fetchFunction(`${API_ENDPOINT}/shop/categories/all`, {
            //         method: 'POST',
            //         headers: {
            //             'content-type': 'application/json',
            //             'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
            //         },
            //         body: JSON.stringify({
            //         })
            //     }).then(res => res.json()).then((result) => {

            //         return {
            //             shopCategories: result

            //         }
            //     })

            // }



        ]


    },
    {
        path: "/interni-shop/:category/:id",
        generateSeoTags: (data, lang) => {
            return {
                title: (data?.data && data.data.name ? data.data.name : 'Interni shop') + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: ShopDetailPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/shop/articles/${match.params.category}/${match.params.id}`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
                    },

                }).then(res => res.json()).then((result) => {

                    // result.item.dateTS = new Date(result.item.date + " " + result.item.time).getTime() / 1000;
                    // if (result && result.item && result.item.gallery) {
                    //     result.item.galleryLength = result.item.gallery.length;
                    // }

                    // if (result && result.item && result.item.shortDescription) {
                    //     if (result.item.shortDescription.split(',')[0] == 'Drage koleginice i kolege' || result.item.shortDescription.split(',')[0] == 'Drage koleginice' || result.item.shortDescription.split(',')[0] == 'Drage kolege') {
                    //         result.item.checkIntro = true;
                    //     }
                    // }
                    return {
                        data: result.item,
                        // gallery: result.item.gallery ? result.item.gallery : [],
                    }
                })

            },

            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }


        ]

    },

    {
        path: "/arhiva-novosti",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Arhiva novosti'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: BlogPage,
        loadData: [
            // (fetchFunction, lang, match) => {
            //     return fetchFunction(`${API_ENDPOINT}/latest/articles/${match.params.category}`, {
            //         method: 'GET',
            //         headers: {
            //             'content-type': 'application/json'
            //         },

            //     }).then(res => res.json()).then((result) => {
            //         for(let i=0; i<result.length; i++){
            //             result[i].dateTS = new Date(result[i].date + " " + result[i].time).getTime()/1000;
            //         }
            //         return {
            //             blogLatest: result,
            //         }
            //     })

            // },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }

        ],
        loadDataWithQuery: [
            (fetchFunction, lang, match, query) => {
                return fetchFunction(`${API_ENDPOINT}/articlesAll`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        page: query.page,
                        lang: lang
                    })
                }).then(res => res.json()).then((result) => {
                    for (let i = 0; i < result.items.length; i++) {
                        result.items[i].dateTS = new Date(result.items[i].date + " " + result.items[i].time).getTime() / 1000;
                    }
                    return {
                        page: query.page ? query.page : 0,
                        items: result.items,
                        total: result.total,

                    }
                })

            }
        ]


    },

    {
        path: "/podesavanja",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Podešavanja'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: ChangePassword,
        loadData: [

            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }

        ],
        loadDataWithQuery: [

        ]


    },

    {
        path: "/interne-novosti/interna-biblioteka",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Interna biblioteka'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: Library,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }

        ],
        loadDataWithQuery: [
            (fetchFunction, lang, match, query) => {
                return fetchFunction(`${API_ENDPOINT}/library`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        page: query.page,
                        lang: lang
                    })
                }).then(res => res.json()).then((result) => {
                    // for(let i=0; i<result.items.length; i++){
                    //     result.items[i].dateTS = new Date(result.items[i].date + " " + result.items[i].time).getTime()/1000;
                    // }
                    return {
                        page: query.page ? query.page : 0,
                        items: result.items,
                        total: result.total,
                    }
                })

            }
        ]


    },
    {
        path: "/predstavljanje-novozaposlenih",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Predstavljanje zaposlenih'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: Employees,
        loadData: [

            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },




        ],
        loadDataWithQuery: [

            (fetchFunction, lang, match, query) => {

                return fetchFunction(`${API_ENDPOINT}/employees`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        page: query.page,
                        lang: lang,
                        active: query.active ? query.active : 0,
                    })
                }).then(res => res.json()).then((result) => {
                    for (let i = 0; i < result.items.length; i++) {
                        result.items[i].dateTS = new Date(result.items[i].date + " " + result.items[i].time).getTime() / 1000;
                    }
                    return {
                        page: query.page ? query.page : 0,
                        active: query.active ? query.active : 0,
                        items: result.items,
                        total: result.total,
                    }
                })

            }
        ]


    },
    {
        path: "/:category/novosti/:submenu",
        generateSeoTags: (data, lang) => {
            return {
                title: data.submenuName + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: BlogPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/latest/articles/${match.params.category}/${match.params.submenu}/0`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {
                    for (let i = 0; i < result.length; i++) {
                        result[i].dateTS = new Date(result[i].date + " " + result[i].time).getTime() / 1000;
                    }
                    return {
                        blogLatest: result,
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/folders/${match.params.category}/${match.params.submenu}`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        folders: data
                    }
                })

            },

        ],
        loadDataWithQuery: [
            (fetchFunction, lang, match, query) => {
                return fetchFunction(`${API_ENDPOINT}/articles/${match.params.category}/${match.params.submenu}`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        page: query.page,
                        lang: lang
                    })
                }).then(res => res.json()).then((result) => {
                    for (let i = 0; i < result.items.length; i++) {
                        result.items[i].dateTS = new Date(result.items[i].date + " " + result.items[i].time).getTime() / 1000;
                    }
                    return {
                        page: query.page ? query.page : 0,
                        items: result.items,
                        total: result.total,
                        submenuName: result.submenuName
                    }
                })

            }
        ]


    },

    {
        path: "/:category/novosti/:submenu/:alias",
        generateSeoTags: (data, lang) => {
            return {
                title: (data.data && data.data.name ? data.data.name : 'Novosti') + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: BlogDetailPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/articles/${match.params.category}/${match.params.submenu}/${match.params.alias}`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {

                    result.item.dateTS = new Date(result.item.date + " " + result.item.time).getTime() / 1000;
                    if (result && result.item && result.item.gallery) {
                        result.item.galleryLength = result.item.gallery.length;
                    }

                    if (result && result.item && result.item.shortDescription) {
                        if (result.item.shortDescription.split(',')[0] == 'Drage koleginice i kolege' || result.item.shortDescription.split(',')[0] == 'Drage koleginice' || result.item.shortDescription.split(',')[0] == 'Drage kolege') {
                            result.item.checkIntro = true;
                        }
                    }
                    return {
                        data: result.item,
                        gallery: result.item.gallery ? result.item.gallery : [],
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/latest/articles/${match.params.category}/${match.params.submenu}/${match.params.alias}`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {

                    for (let i = 0; i < result.items.length; i++) {
                        result.items[i].dateTS = new Date(result.items[i].date + " " + result.items[i].time).getTime() / 1000;
                    }

                    return {
                        blogLatest: result.items,
                        category: result.category
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }


        ]

    },
    {
        path: "/:category/novosti/:submenu/folder/:folder",
        generateSeoTags: (data, lang) => {
            return {
                title: data.submenuName + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: FolderBlogPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/latest/articles/${match.params.category}/${match.params.submenu}/0`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {
                    for (let i = 0; i < result.length; i++) {
                        result[i].dateTS = new Date(result[i].date + " " + result[i].time).getTime() / 1000;
                    }
                    return {
                        blogLatest: result,
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
        ],
        loadDataWithQuery: [

        ]
    },
    {
        path: "/:category/novosti/:submenu/folder/:folder/:alias",
        generateSeoTags: (data, lang) => {
            return {
                title: (data.data && data.data.name ? data.data.name : 'Novosti') + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: FolderBlogDetailPage,
        loadDataWithQuery: [],
        loadData: [

        ]

    },



    {
        path: "/mjere-predostroznosti",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Novosti'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: PrecautionsPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/precautions`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {

                    return {
                        data: result,
                    }
                })

            },

            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }

        ]

    },

    {
        path: '/novi-clan',
        generateSeoTags: (data, lang) => {
            return {
                title: 'Novi član' + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: NewMemberPreview,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },


        ]

    },


    {
        path: "/anketa",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Anketa' + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: PoolPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/pools/all`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${typeof window != 'undefined' ? localStorage.getItem('token') : null}`
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        pool: data,
                        answers: data.answers,
                        comments: data.comments,
                        showCommentBox: !data.userCommented && data.userVoted ? true : false
                    }
                })

            },

        ]

    },
    {
        path: "/anketa-slike",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Anketa' + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: PoolImagePage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/pools-images/all`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        pool: data,
                        answers: data.answers,
                        comments: data.comments
                    }
                })

            },

        ]

    },
    {
        path: "/anketa-video",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Anketa' + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: PoolVideoPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/pools-video/all`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        pool: data,
                        answers: data.answers,
                        comments: data.comments
                    }
                })

            },

        ]

    },



    {
        path: "/dostavne-linije",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Dostavne linije'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: Service1Page,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/deliveryLines`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        delivery: data.deliveryLines
                    }
                })

            }
            // (fetchFunction, lang, match) => {
            //     return fetchFunction('${API_ENDPOINT}/documents/all', {
            //         method: 'GET',
            //         headers: {
            //             'content-type': 'application/json'
            //         },

            //     }).then(res => res.json()).then((result) => {

            //         return {
            //             documents: result,
            //         }
            //     })

            // }
            // (fetchFunction, lang, match) => {
            //     return fetchFunction(`${API_ENDPOINT}/services/1/${lang}/${match.params.alias}`, {
            //         method: 'GET',
            //         headers: {
            //             'content-type': 'application/json'
            //         },

            //     }).then(res => res.json()).then((result) => {

            //         return {
            //             data: result,
            //         }
            //     })

            // },



        ]
    },
    {
        path: "/kontakt",
        generateSeoTags: (data, lang) => {
            return {
                title: 'Sugestije zaposlenih'.translate(lang) + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: ContactPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }
        ]

    },
    {
        path: "/:category/dokumenti",
        generateSeoTags: (data, lang) => {
            return {
                title: data.pageTitle + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: DocumentPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/documents/${match.params.category}`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {

                    return {
                        documents: result,
                    }
                })

            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }


        ]
    },
    {
        path: "/projects",
        generateSeoTags: (data, lang) => {
            return {
                title: data.pageTitle + ' - Interni portal EuroExpress brza pošta'.translate(lang),
                description: ''.translate(lang),
                'og:image': 'https://interni.euroexpress.ba/share.png'
            }
        },
        component: LiderboardPage,
        loadData: [
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/data/dynamic-tables/projects?isActive=true`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    },

                }).then(res => res.json()).then((result) => {
                    return {
                        projects: result
                    }
                })
            },
            (fetchFunction, lang, match) => {
                return fetchFunction(`${API_ENDPOINT}/home`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((data) => {
                    return {
                        home: data
                    }
                })

            }
        ]
    },



];

export function generateRoutes(r) {
    let newRoutes = [];
    for (let i = 0; i < r.length; i++) {
        newRoutes.push(r[i]);

        newRoutes.push({
            ...r[i],
            path: linkTranslates.en[r[i].path]
        })
    }
    return newRoutes;
}